import { Helmet } from "react-helmet-async";
export default function MetaTitle({title}){
    return(
        <Helmet>
            <title>{`${title}  Sea Sense Interdisciplinary Research and IT Solution (OPC) Pvt.Ltd.`}</title>
        </Helmet>
    )
}